// glode-policy-init.js — script in pagina di prototipo/premium/policy.html (P26).
// Unica modifica: rimossa la chiamata a montaTelaio(), che nel tema monterebbe un secondo
// telaio sopra quello di Horizon. Tutto il resto è identico all'originale.
montaPolicyPremium();
